var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSendDiagonal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "sendDiagonal_svg__svg-safari-fix",
  viewBox: "0 0 20 20",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.477 2.49a1.49 1.49 0 0 0-1.533-.358L3.277 6.391a1.497 1.497 0 0 0-.15 2.775l5.242 2.433 2.433 5.242c.25.533.775.866 1.359.866h.083a1.48 1.48 0 0 0 1.333-1.016l4.259-12.659a1.49 1.49 0 0 0-.359-1.533zM14.37 4.417l-5.55 5.55-4.6-2.134zM12.127 15.74l-2.133-4.6 5.55-5.55z"
})));
export default SvgSendDiagonal;